import styles from './button.module.css'

const Button = ({active, disabled, ...props}) => (
  <button
    className={styles.button}
    tabIndex={!active || disabled ? -1 : null}
    aria-hidden={!active ? true : null}
    aria-disabled={!active || disabled ? true : null}
    {...props}
  />
)

export default Button
